// gatsby-browser.js
// import "@UA-Stratcom/minerva/css";
import "./src/styles/main.css"
import "./src/styles/navigation.css"
import "./src/styles/sidebar.css"
import "./src/minerva/minerva.css"
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import "@fortawesome/fontawesome-free/css/all.min.css";
import * as React from "react";


// export const onRenderBody = ({ setHeadComponents }) => {
//   setHeadComponents([
//     <link
//       key="ua-fontawesome"
//       rel="stylesheet"
//       href="https://assetfiles.ua.edu/fonts/fa_v6/fontawesome.css"  // UA Pro version
//       crossOrigin="anonymous"
//     />,
//   ]);
// };
// import "./src/minerva/minerva.js"
// Load minerva.js only after the browser DOM is ready
export const onClientEntry = () => {
  const script = document.createElement("script");
  script.src = "/minerva/minerva.js";  // Adjust path – see note below
  script.async = true;                 // Optional: non-blocking
  document.body.appendChild(script);

  // Optional: Log for debug
  script.onload = () => {
    console.log("Minerva JS loaded successfully");
  };
  script.onerror = () => {
    console.error("Failed to load Minerva JS");
  };
};